import { useCallback, useContext } from 'react';
import { HeaderContext, HeaderPopovers } from '../HeaderProvider';

export const useActivityPopoverController = () => {
  const { setActivePopover } = useContext(HeaderContext);

  const handleActivityFeedToggle = useCallback(
    (next: boolean) => {
      setActivePopover((prev) => {
        if (!next) {
          return prev === HeaderPopovers.ACTIVITY ? null : prev;
        }

        return HeaderPopovers.ACTIVITY;
      });
    },
    [setActivePopover],
  );

  const handleActivityFeedClick = useCallback(() => {
    setActivePopover((prev) => (prev === HeaderPopovers.ACTIVITY ? null : HeaderPopovers.ACTIVITY));
  }, [setActivePopover]);

  return {
    handleActivityFeedClick,
    handleActivityFeedToggle,
  };
};
